import styled from 'styled-components';
import Grid from 'styled-components-grid';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import breakpoint from 'styled-components-breakpoint';
import { colors } from '@components/ListItemFacility/styles';

export const StyledCardWrapper = styled(Grid.Unit)`
  padding: 15px;

  ${breakpoint('mobile', 'desktop')`
    padding: 10px;
  `}
`;

export const StyledCardInner = styled.div`
  cursor: pointer;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: hidden;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
`;

export const StyledPostCardList = styled(Grid)``;

export const StyledLink = styled.a`
  display: block;
  text-decoration: none;
  height: 100%;
`;

export const StyledImageCover = styled.div`
  width: 100%;
  aspect-ratio: 3/2;
  margin-bottom: 0.5rem;
`;

export const StyledPostImage = styled(LazyLoadImage)`
  display: flex;
  width: 100%;
  aspect-ratio: inherit;
`;

export const StyledCardDate = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-weight: 600;
  font-style: italic;
  font-size: 12px;
  color: ${colors.grayText};
`;

export const StyledCardTitle = styled.h3`
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 24px;
  max-height: 48px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  color: black;
  padding: 0 10px;
  line-height: 1.4;

  ${breakpoint('mobile', 'desktop')`
    padding: 0 10px;
    font-size: 12px;
    margin-bottom: 0.5rem;
  `}
`;

export const StyledArticleSummary = styled.span`
  line-height: 1.5;
  padding: 0 10px;
  color: black;
  margin-bottom: 3rem;
  line-height: 24px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;

  ${breakpoint('mobile', 'desktop')`
    padding: 0 10px;
    font-size: 12px;
    margin-bottom: 3rem;
  `}
`;

export const StyledDepartment = styled.div`
 margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 24px;
  max-height: 48px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
 color: #0A82EB;
  padding: 0 10px;
  line-height: 1.4;

  ${breakpoint('mobile', 'desktop')`
    padding: 0 10px;
    font-size: 12px;
  `}
`;
